module.exports = {"pathContext":{"slug":"/ml"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/ml.json
// module id = 572
// module chunks = 21857691331462